import PaginationPageSizeWidget from '../PaginationPageSizeWidget';
import './style.scss';
import * as TableType from './table.types';

/**
 * DataTable component:
 * standard data table component and also providing pagination, sorting,
 * and filtering
 */
export default function DataTable({
  isLoading,
  setIsLoading,
  filter,
  sort,
  data,
  showPagination,
  showPageSizeChanger,
  columns,
  totalPages,
  totalItems,
  handleChangePageNo,
  currentPageNo,
  currentPageSize,
  handleChangePageSize,
  onRowClick,
  showClickableRows,
  tooltipText,
  topContent,
  topContentAlignment,
  topContentColRatioLeft,
  topContentColRatioRight,
  topContentColRatioLeftMd,
  topContentColRatioRightMd,
  showMultiSelect,
  multiSelectRows,
  setMultiSelectRows,
  underSearchBarContent,
  underSearchBarContentShowForNoItems,
}) {
  const getTableDataProps = () => {
    return {
      columns,
      data: data.map((item) => {
        let cur = item;
        for (let i in cur) {
          if (cur[i] === null || cur[i] === undefined || cur[i] === '') {
            cur[i] = '-';
          }
        }
        return cur;
      }),
      onRowClick: onRowClick ? onRowClick : () => {},
      showClickableRows: showClickableRows,
      tooltipText: tooltipText,
      topContent: topContent,
      topContentAlignment: topContentAlignment,
      topContentColRatioLeft: topContentColRatioLeft,
      topContentColRatioRight: topContentColRatioRight,
      topContentColRatioLeftMd: topContentColRatioLeftMd,
      topContentColRatioRightMd: topContentColRatioRightMd,
      showMultiSelect: showMultiSelect,
      multiSelectRows: multiSelectRows,
      setMultiSelectRows: setMultiSelectRows,
      underSearchBarContent: underSearchBarContent,
      underSearchBarContentShowForNoItems: underSearchBarContentShowForNoItems,
    };
  };

  return (
    <div className="dataTable">
      {!isLoading ? (
        <>
          {data && data.length > 0 ? (
            <>
              {filter && sort && (
                <TableType.FilterSorting {...getTableDataProps()} />
              )}
              {!filter && !sort && <TableType.Basic {...getTableDataProps()} />}
              {showPagination && (
                <PaginationPageSizeWidget
                  totalPages={totalPages}
                  totalItems={totalItems}
                  handleChangePageNo={handleChangePageNo}
                  currentPageNo={currentPageNo}
                  handleChangePageSize={handleChangePageSize}
                  currentPageSize={currentPageSize}
                  showPageSizeChanger={showPageSizeChanger}
                  currentItemsCount={data.length}
                />
              )}
            </>
          ) : underSearchBarContentShowForNoItems ? (
            <div>
              {underSearchBarContent}
              <br />
              <h4 className="text-center pt-4">No Data Found</h4>
            </div>
          ) : (
            <h4 className="text-center pt-4">No Data Found</h4>
          )}
        </>
      ) : (
        <div className="py-5 d-flex flex-column align-items-center">
          <div className="d-flex justify-content-center gap-1">
            <div
              className="spinner-grow spinner-grow-sm text-primary"
              role="status"
            ></div>
            <div
              className="spinner-grow spinner-grow-sm text-primary"
              role="status"
            ></div>
            <div
              className="spinner-grow spinner-grow-sm text-primary"
              role="status"
            ></div>
          </div>
          <br />
          <div className="fw-bold text-primary">Loading data...</div>
        </div>
      )}
    </div>
  );
}
